import { keys, difference } from 'lodash';
class SpriteSystem {
  constructor(systems) {
    this.systems = systems;
    this.spriteHitKeys = [];
    this.spriteCache = {};
    this.__spriteCacheLen = 0;
  }

  before(dt) {
    this.spriteHitKeys = [];
  }

  createAnimatedSprite(ent) {
    const uuid = ent.uuid.uuid;

    const animation = ent.sprite.anims[0];
    const frames = animation.frames.map( (frame) => {
      let texture;
      if (!frame.atlas) {
        texture = this.systems.gameobjects.resources[frame.sprite].texture;
      } else {
        texture = this.systems.gameobjects.resources[frame.atlas].textures[frame.texture]
      }
      if (!texture || !texture.baseTexture) {
        console.error('could not find texture', frame);
      }
      if (!texture._uvs) {
        console.error(frame.texture, 'broken?');
      } else {
      }
      return texture;

    });
    const sprite = new PIXI.AnimatedSprite(frames, false);
    sprite.mask = null;
    sprite.animationSpeed = animation.timePerFrame * 100;
    //sprite.animationSpeed = 1 / animation.timePerFrame;
    sprite.loop = animation.loopByDefault;
    
    const textureWidth = frames[0].width;
    const textureHeight = frames[0].height;
    sprite.scale.x = 1 / textureWidth;
    sprite.scale.y = 1 / textureHeight;

    sprite.x = 0;
    sprite.y = 0;
    sprite.visible = false;
    sprite.anchor.x = ent.transform.anchorx;
    sprite.anchor.y = ent.transform.anchory;
    ent.sprite.firstFrame = 2;

    this.systems.addInnerContainer(uuid);
    const parent = this.systems.pixiContainers[uuid].inner;

    parent.addChild(sprite);

    this.spriteCache[uuid] = {
      texture:frames[0],
      sprite,
      parent,
      animated:true,
      frames:animation.frames
    }
    this.__spriteCacheLen++;

  }

  createSprite(ent) {
    const uuid = ent.uuid.uuid;
    let texture;
    if (!ent.sprite.isAtlas) {
      texture = this.systems.gameobjects.mipmappedTextures[ent.sprite.texture];
    } else {

      // the atlas should be there if the game has not been packed by the packer
      if (this.systems.gameobjects.resources[ent.sprite.atlas]) {
        texture = this.systems.gameobjects.resources[ent.sprite.atlas].textures[ent.sprite.texture]
      }

      // try to find in mipmappedTextures which is where the packed textures go from the packer
      if (!texture) {
        const packedTextureName = ent.sprite.texture.replace(/\//g, '_');
        texture = this.systems.gameobjects.mipmappedTextures[packedTextureName];
      }
    }

    if (!texture) {
      console.error("tried my best, couldnt find the texture.");
      ent.addComponent(this.systems.Components.Destroy);
      return;
    }

    const textureWidth = texture.width;
    const textureHeight = texture.height;
    //const textureWidth = texture.width;
    //const textureHeight = texture.height;

    let sprite = this.systems.getScaledSprite(ent.sprite.texture, texture, 1 / textureWidth * 1, 1 / textureHeight * 1);
    sprite.mask = null;
    sprite.x = 0;
    sprite.y = 0;
    sprite.visible = false;
    sprite.anchor.x = ent.transform.anchorx;
    sprite.anchor.y = ent.transform.anchory;

    ent.sprite.firstFrame = 2;

    if (ent.sprite.ost) {
      ent.transform.localScale.x = ent.sprite.os.x;
      ent.transform.localScale.y = ent.sprite.os.y;
    }

    this.systems.addInnerContainer(uuid);
    const parent = this.systems.pixiContainers[uuid].inner;

    parent.addChild(sprite);

    this.spriteCache[uuid] = {
      texture:ent.sprite.texture,
      sprite:sprite,
      parent,
      animated:false
    }
    this.__spriteCacheLen++;

  }

  update(dt, ent) {
    const uuid = ent.uuid.uuid;
    let cache = this.spriteCache[uuid];
      //t
    if (cache && !cache.animated && cache.texture !== ent.sprite.texture) {
      ent.addComponent(this.systems.Components.Destroy);
    }
    if (!cache) {

      if (ent.sprite.anims) {
        this.createAnimatedSprite(ent);
      } else {
        this.createSprite(ent);
      }

      const slots = this.systems.findSlots(ent, ent.sprite);
      this.systems.addComponent(ent, slots);

      this.systems.createSceneGraphChildren(ent, ent.transform);

    }

    cache = this.spriteCache[uuid];

    if (ent.sprite.firstFrame >= 1) {
      ent.sprite.firstFrame--;
    }
    if (ent.sprite.firstFrame === 0) {
      cache.sprite.visible = true;
      ent.sprite.firstFrame = -1;
      if (cache.animated) {
        cache.sprite.play();
      }
    }
    if (ent.sprite.firstFrame < 0) {
      if (cache.animated) {
        const speedModifier = (cache.frames[cache.sprite.currentFrame].frameDelay || 0.1) / 0.1;
        cache.sprite.update((dt/1000) / speedModifier);
      }
    }

    this.spriteHitKeys.push(uuid);
  }

  after(dt) {
    const hitKeys = this.spriteHitKeys;
    if (this.__spriteCacheLen !== hitKeys.length) {
      const toRemove = difference(keys(this.spriteCache), hitKeys);
      const toRemoveLength = toRemove.length;
      for (let i = 0; i < toRemoveLength; i++) {
          const uuid = toRemove[i];
          const sprite = this.spriteCache[uuid].sprite;
          const animated = this.spriteCache[uuid].animated;
          //this.gameobjects.app.stage.removeChild(sprite);
          if (!animated) {
            this.systems.returnToPool(this.spriteCache[uuid].texture, sprite, this.spriteCache[uuid].parent);
          } else {
            this.spriteCache[uuid].parent.removeChild(sprite);
            sprite.stop();
            sprite.destroy();
          }
          delete this.spriteCache[uuid];
          this.__spriteCacheLen--;
      }
    }
  }
}

export default SpriteSystem;
